var config = window.__CONFIG__;
delete window.__CONFIG__;
export default config && config.default || config || {};